import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-4cf05ac6"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "wrapper-container"
};
var _hoisted_2 = {
  class: "question-header"
};
var _hoisted_3 = ["disabled", "onUpdate:modelValue"];
var _hoisted_4 = {
  key: 0,
  class: "question-image-box"
};
var _hoisted_5 = {
  key: 0,
  class: "title-success"
};
var _hoisted_6 = {
  key: 1,
  class: "title-error"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_CustomAudio = _resolveComponent("CustomAudio");
  var _component_Image = _resolveComponent("Image");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_ctx.question.audioUrl ? (_openBlock(), _createBlock(_component_CustomAudio, {
    key: 0,
    audioUrl: _ctx.question.audioUrl
  }, null, 8, ["audioUrl"])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questArr, function (item, index) {
    return _openBlock(), _createElementBlock("span", {
      key: index
    }, [_createTextVNode(_toDisplayString(item) + " ", 1), index !== _ctx.questArr.length - 1 ? _withDirectives((_openBlock(), _createElementBlock("input", {
      key: 0,
      disabled: _ctx.answerMode,
      class: "fill-blank-input",
      "onUpdate:modelValue": function ($event) {
        return _ctx.answerList[index] = $event;
      },
      onBlur: _cache[0] || (_cache[0] =
      //@ts-ignore
      function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        return _ctx.blurChange && _ctx.blurChange.apply(_ctx, args);
      })
    }, null, 40, _hoisted_3)), [[_vModelText, _ctx.answerList[index]]]) : _createCommentVNode("", true)]);
  }), 128))]), _ctx.question.picUrl ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_Image, {
    src: _ctx.question.picUrl,
    alt: "question image"
  }, null, 8, ["src"])])) : _createCommentVNode("", true), _ctx.answerMode && _ctx.currentPaperAnswer ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(['question-answer-container', _ctx.isUserAnswerRight ? 'question-answer-container-success' : 'question-answer-container-error'])
  }, [_ctx.isUserAnswerRight ? (_openBlock(), _createElementBlock("span", _hoisted_5, "回答正确")) : (_openBlock(), _createElementBlock("span", _hoisted_6, "回答错误")), _createElementVNode("span", null, "正确答案：" + _toDisplayString(_ctx.currentPaperAnswer), 1)], 2)) : _createCommentVNode("", true)]);
}